import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import { selectSubject, set } from "./subjectSlice";
import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    "&:focus": {
      color: "#FF0000",
    },
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
    },
  },
}));

export function Subject() {
  const classes = useStyles();
  const subjectValue = useSelector(selectSubject);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <TextField
        required
        id="standard-textarea"
        label={
          language !== undefined
            ? language === "TH"
              ? "หัวข้อ"
              : "Subject"
            : "Subject"
        }
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "หัวข้อ"
              : "Subject"
            : "Subject"
        }
        variant="outlined"
        color="secondary"
        value={subjectValue}
        onChange={(e) => {
          if (e.target.value.length <= 150) {
            dispatch(set(e.target.value));
          }
        }}
      />{" "}
    </form>
  );
}
